import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { mapSearchParamsToFilters } from '~/shared/lib/utils'
import { Filter } from '~/shared/ui/AsyncGrid'
import { FileExportBlob } from '~/shared/ui/FileExport'

type AppealExportProps = {
  defaultFilters?: Filter
  exportFn: (search: string) => Promise<Blob>
}

export const AppealExport = ({
  defaultFilters,
  exportFn,
}: AppealExportProps) => {
  const [searchParams] = useSearchParams()

  const filters = useMemo(
    () => ({
      ...mapSearchParamsToFilters(searchParams),
      ...defaultFilters,
    }),
    [defaultFilters, searchParams],
  )

  const isFiltersValid = useMemo(
    () => filters.createdAtFrom && filters.createdAtTo,
    [filters.createdAtFrom, filters.createdAtTo],
  )

  const errorMessageFn = useCallback(() => {
    snackbarEnqueued({
      messageI18n: 'alert.set start and end date in filter',
      variant: 'error',
    })
  }, [])

  const handleExportFn = async () =>
    exportFn(new URLSearchParams(filters).toString())

  return (
    <FileExportBlob
      titleI18n='button.export to excel'
      fn={isFiltersValid ? handleExportFn : errorMessageFn}
    />
  )
}
